import {IPaylodAction, ISidebarDispatcher, IActionDispatcher} from '../../interfaces/dispatchers'
import SidebarAction from '../../enums/ActionTypes/SidebarAction'
import {IAppStore} from '../../../interfaces/reducers'

export class SidebarDispatcher implements ISidebarDispatcher {
  constructor() {
    this.setSelected = this.setSelected.bind(this)
    this.setMinimized = this.setMinimized.bind(this)
    this.setLong = this.setLong.bind(this)
  }
  public setSelected(selected: string) {
    return (dispatch: (data: IPaylodAction<string> | IActionDispatcher) => void, getStore: () => IAppStore) => {
      if (getStore().sidebar.currentlySelected == selected) {
        dispatch(this.setMinimized(!getStore().sidebar.minimize))
      } else {
        dispatch(this.setMinimized(false))
        dispatch({
          type: SidebarAction.SET_SELECTED,
          payload: selected
        })
      }
    }
  }
  public setMinimized(minimized: boolean) {
    return (dispatch: (data: IPaylodAction<boolean>) => void, getStore: () => IAppStore) => {
      dispatch({
        type: SidebarAction.SET_MINIMIZED,
        payload: minimized
      })
      let times = 0
      const mapService = getStore().map.mapService
      if (mapService) {
        const mapRefresher = setInterval(() => {
          times++
          mapService.updateSize()
          if (times == 10) {
            clearInterval(mapRefresher)
          }
        }, 20)
        setTimeout(() => {}, 200)
      }
    }
  }

  public setLong(long: boolean) {
    return (dispatch: (data: IPaylodAction<boolean>) => void) => {
      dispatch({
        type: SidebarAction.SET_LONG,
        payload: long
      })
    }
  }
}
